import React from "react";

const stats = [
  { value: "10+", label: "Év tapasztalat" },
  { value: "100+", label: "Elégedett ügyfél" },
  { value: "100%", label: "Garancia" },
];

export const About = (props) => {
  return (
    <section id="about">
      <div className="container">
        <div className="row">
          {/* Image column */}
          <div className="col-xs-12 col-md-6">
            <img src="./img/team/05.jpg" className="img-responsive" alt="" />
          </div>

          {/* Text column */}
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Rólam</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>

              {/* Stat pills */}
              <div className="about-stats">
                {stats.map((s) => (
                  <div key={s.label} className="about-stat-item">
                    <span className="about-stat-value">{s.value}</span>
                    <span className="about-stat-label">{s.label}</span>
                  </div>
                ))}
              </div>

              <h3>Miért válassz?</h3>

              {/* Two-column check list */}
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul className="about-checklist">
                    {props.data
                      ? props.data.Why.map((d, i) => (
                        <li key={`${d}-${i}`}>
                          <span className="about-check">&#10003;</span>
                          {d}
                        </li>
                      ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul className="about-checklist">
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                        <li key={`${d}-${i}`}>
                          <span className="about-check">&#10003;</span>
                          {d}
                        </li>
                      ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
